if (document.querySelector('#about-tudor-slider')) {
if (document.querySelectorAll('#about-tudor-slider .tudor-blog-item-custom')) {
    var flkty = new Flickity('#about-tudor-slider .tudor-blog-lists', {
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        lazyLoad: 2,
        prevNextButtons: true,
        pageDots: true,
        groupCells: false,
        autoPlay: false, 
        dragThreshold: 10,
        selectedAttraction: 0.2, 
        friction: 0.8, 
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 4,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2,
                  }
              }
          ]
    });
    // Measure again with the final CSS, fonts (Asap from tudor.css) and images.
    window.addEventListener('load', function () { flkty.resize(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { flkty.resize(); });
}
}
